import React, { FunctionComponent } from "react";
import { MessageType } from "../../enums.generated";
import { getMessageIcon } from "../../functions/get-message-icon";
import { Message } from "../../models/app";

// function gets the toast CSS class to apply by message type
const getToastCssClass = (type: MessageType) => {
	let cssClass = "toast ";
	switch (type) {
		case MessageType.Error:
			cssClass += "toast-danger";
			break;
		case MessageType.Success:
			cssClass += "toast-success";
			break;
		case MessageType.Warning:
			cssClass += "toast-warning";
			break;
		default:
			cssClass += "toast-info";
			break;
	}
	return cssClass;
}

/**
 * Toast component. Outputs a Bootstrap toast.
 * @param props Configuration properties.
 * @see Message
 */
export const Toast: FunctionComponent<{ options: Message }> = (props: { options: Message }) => {

	// dismiss toast handler, triggered by clicking the close toast icon
	const dismissHandler = (event: React.MouseEvent) => {

		event.preventDefault();

		if (props.options.dismiss)
			props.options.dismiss(props.options);
	};

	// create dismiss button element
	const dismissButton = props.options.dismissible !== false ?
		<button type="button" className="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close" onClick={dismissHandler}>
			<span aria-hidden="true">&times;</span>
		</button> : null;

	const messageType = props.options.type ?? MessageType.Info;

	return (
		<div className={getToastCssClass(messageType)} role="alert" aria-live="assertive" aria-atomic="true">
			<div className="toast-header">
				<i className={getMessageIcon(messageType)}></i>
				<strong className="toast-title">{props.options.title}</strong>
				{dismissButton}
			</div>
			<div className="toast-body">
				{props.options.text}
			</div>
		</div>
	)
}